import React, { useState } from "react";
import styles from "./Calendar.module.scss";
import CustomDropdown from "./CustomDropdown";
import { CalendarCheckIcon } from "../icons/icons";

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const years = [2025, 2026, 2027];
const daysOfWeek = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

function getDaysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
function getDay(date) {
    // Monday = 0, Sunday = 6
    let d = date.getDay();
    return d === 0 ? 6 : d - 1;
}
function isToday(date) {
    const today = new Date();
    return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    );
}
function isPastDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
}

const Calendar = ({ selectedDate, onDateSelect }) => {
    const today = new Date();
    const [CheckIcon, setCheckIcon] = useState(true);
    const [month, setMonth] = useState(today.getMonth());
    const [year, setYear] = useState(today.getFullYear());
    const [date, setDate] = useState(selectedDate || null);

    const daysInMonth = getDaysInMonth(year, month);
    const startWeekday = getDay(new Date(year, month, 1));
    const blankDaysCount = (startWeekday + 7) % 7;
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = month === 0 ? year - 1 : year;
    const daysInPrevMonth = getDaysInMonth(prevYear, prevMonth);
    const totalCells = 42;
    const usedCells = blankDaysCount + daysInMonth;
    const remainingCells = totalCells - usedCells;

    return (
        <div className={styles.calendarContainer}>
            {/* Month and Year Custom Dropdowns */}
            <div className={styles.headerRow}>
                <CustomDropdown
                    options={months}
                    selected={{ label: months[month], value: month }}
                    onChange={(opt) => {
                        setMonth(Number(opt.value));
                        setDate(null);
                    }}
                    placeholder="Month"
                    inputClassName={styles.calendarInput}
                    style={{
                        background: "#ffff",
                        height: "38px",
                        maxWidth: "80%",
                    }}
                />
                <CustomDropdown
                    options={years.map((y) => ({ label: y, value: y }))}
                    selected={{ label: year, value: year }}
                    onChange={(opt) => {
                        setYear(Number(opt.value));
                        setDate(null);
                    }}
                    placeholder="Year"
                    inputClassName={styles.calendarInput}
                    style={{
                        background: "#ffff",
                        height: "38px",
                        maxWidth: "80%",
                    }}
                />
            </div>
            {/* Weekday Headers */}
            <div className={styles.daysOfWeekRow}>
                {daysOfWeek.map((day) => (
                    <div key={day} className={styles.dayOfWeek}>
                        {day}
                    </div>
                ))}
            </div>
            {/* Calendar Days */}
            <div className={styles.daysGrid}>
                {/* Previous Month Days */}
                {Array.from({ length: blankDaysCount }, (_, i) => {
                    const day = daysInPrevMonth - blankDaysCount + i + 1;
                    return (
                        <div
                            key={`prev-${day}`}
                            className={`${styles.dayCell} ${styles.faded}`}
                        >
                            <div className={styles.dayCellContainer}>{day}</div>
                        </div>
                    );
                })}
                {/* Current Month Days */}
                {Array.from({ length: daysInMonth }, (_, i) => {
                    const day = i + 1;
                    const cellDate = new Date(year, month, day);
                    const isSelected =
                        date &&
                        cellDate.getDate() === date.getDate() &&
                        cellDate.getMonth() === date.getMonth() &&
                        cellDate.getFullYear() === date.getFullYear();
                    const isPast = isPastDate(cellDate);
                    return (
                        <div
                            key={day}
                            onClick={() => !isPast && setDate(cellDate)}
                            className={
                                `${styles.dayCell} ` +
                                (isPast ? styles.past : "") +
                                (isSelected && !isPast
                                    ? " " + styles.selected
                                    : "")
                            }
                            style={{
                                cursor: isPast ? "not-allowed" : "pointer",
                            }}
                        >
                            <div className="dayCheckContainer">
                                <div
                                    className={
                                        day < 10
                                            ? styles.singleDigit
                                            : styles.doubleDigit
                                    }
                                >
                                    {day}
                                </div>
                                <div>
                                    {" "}
                                    <CalendarCheckIcon />
                                </div>
                            </div>
                            {/* {CheckIcon && } */}
                        </div>
                    );
                })}
                {/* Next Month Days */}
                {Array.from({ length: remainingCells }, (_, i) => {
                    const day = i + 1;
                    return (
                        <div
                            key={`next-${day}`}
                            className={`${styles.dayCell} ${styles.faded}`}
                        >
                            <div className={styles.dayCellContainer}>{day}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Calendar;
